import { useMutation, useQuery } from "@apollo/client";
import {
  ADD_LEGAL_REPRESENTATIVE_MUTATION,
  GET_LEGAL_REPRESENTATIVE,
  UPDATE_LEGAL_REPRESENTATIVE_MUTATION,
} from "../graphQl/LegalRepresentativeAPI";

// `skip` (options) : à passer à true quand legalRepresentativeId vient d'être
// obtenu localement (mutation MT_ADD_LEGAL_REPRESENTATIVE déjà en main, donc
// déjà dans le formulaire) plutôt que chargé depuis une route d'édition — évite
// un QR_GET_LEGAL_REPRESENTATIVE redondant juste après la création.
export const useLegalRepresentativeData = (
  establishmentId,
  legalRepresentativeId,
  { skip: extraSkip = false } = {}
) => {
  const { data, loading, error } = useQuery(GET_LEGAL_REPRESENTATIVE, {
    variables: { establishmentId, legalRepresentativeId },
    skip: !establishmentId || !legalRepresentativeId || extraSkip,
    fetchPolicy: "cache-and-network",
  });

  return {
    legalRepresentative: data?.QR_GET_LEGAL_REPRESENTATIVE?.data || null,
    loading,
    error,
  };
};

export const useLegalRepresentative = () => {
  const [addMutation, { loading: isAdding }] = useMutation(
    ADD_LEGAL_REPRESENTATIVE_MUTATION
  );
  const [updateMutation, { loading: isUpdating }] = useMutation(
    UPDATE_LEGAL_REPRESENTATIVE_MUTATION
  );

  const addLegalRepresentative = (establishmentId, legalRepresentativeInput) =>
    addMutation({ variables: { establishmentId, legalRepresentativeInput } });

  const updateLegalRepresentative = (
    establishmentId,
    legalRepresentativeId,
    legalRepresentativeInput
  ) =>
    updateMutation({
      variables: { establishmentId, legalRepresentativeId, legalRepresentativeInput },
    });

  return {
    addLegalRepresentative,
    updateLegalRepresentative,
    loading: isAdding || isUpdating,
  };
};
